// Multi-language dictionary for Arthniti Financial Services
// Languages: en, hi, mr, gu — full coverage for UI chrome + service titles/taglines

export const LANGUAGES = [
  { code: "en", label: "English", native: "English" },
  { code: "hi", label: "Hindi", native: "हिन्दी" },
  { code: "mr", label: "Marathi", native: "मराठी" },
  { code: "gu", label: "Gujarati", native: "ગુજરાતી" },
];

const dict = {
  en: {
    nav: { home: "Home", about: "About Us", services: "Services", career: "Career", contact: "Contact", calculators: "Calculators", servicesHub: "All Services Hub" },
    cta: { start: "Start Your Investments Today", talk: "Talk to Our Expert", learnMore: "Learn More", submit: "Submit", calculate: "Calculate", book: "Book Free Consultation", viewAll: "View all services", back: "Back" },
    hero: {
      headline: "Your Trusted Partner for a Wealthier Tomorrow",
      sub: "Invest Smarter. Plan Better. Achieve More. — With Arthniti Financial Services, an AMFI-Registered Mutual Fund Distributor.",
      legacy: "25+ Years of Legacy",
      caption: "Personal consultancy that puts your family first.",
      mumbai: "Mumbai · Dadar (East)",
      badges: ["AMFI Registered", "NISM Certified", "Multiple Happy Families"],
    },
    stats: { aum: "AUM Distributed", families: "Happy Families Served", years: "Years of Trust", amcs: "AMCs Partnered" },
    sections: {
      services: "Our Services",
      whyChoose: "Why Choose Arthniti",
      whyTitle: "Built on technology. Powered by relationships.",
      how: "How It Works",
      howTitle: "Start in 3 simple steps",
      testimonials: "What Our Clients Say",
      testimonialsTitle: "Trust earned, one family at a time.",
      partners: "Trusted Partners",
      partnersTitle: "40+ AMCs, top banks & insurers",
      insurancePartners: "Insurance Partners",
      bankingPartners: "Banking Partners",
      faqs: "Frequently Asked Questions",
      faqsLong: "FAQ",
      tools: "Financial Calculators",
      toolsLong: "Tools",
      team: "Our Team",
      teamTitle: "The people behind your portfolio.",
      values: "Core Values",
      valuesTitle: "Six principles that govern every interaction.",
      story: "Our Story",
      storyHeadline: "The policy of finance, since 1999.",
      missionLabel: "Mission",
      visionLabel: "Vision",
      regulatory: "Regulatory Information",
      offerings: "Key offerings & benefits",
      categories: "Categories we distribute",
    },
    footer: {
      compliance: "AMFI-Registered Mutual Fund Distributor | ARN-40602",
      risk: "Mutual fund investments are subject to market risks. Please read all scheme-related documents carefully.",
      office: "Registered Office",
      contact: "Contact",
      links: "Quick Links",
      services: "Services",
      copyright: "© 2025 Arthniti Financial Services. All Rights Reserved.",
      disclaimer: "Disclaimer",
      privacy: "Privacy Policy",
      terms: "Terms of Use",
      grievance: "Grievance Redressal",
    },
    contact: {
      title: "Get in Touch",
      sub: "We respond within 24 business hours.",
      headline: "Let's start a conversation.",
      name: "Full Name",
      phone: "Phone Number",
      email: "Email Address",
      city: "City",
      topic: "How can we help you?",
      topicPlaceholder: "Choose a topic",
      message: "Your Message",
      success: "Thank you! We will reach out within 24 business hours.",
      sending: "Sending...",
      whatsapp: "Chat on WhatsApp",
      hours: "Mon – Sat: 10:00 AM – 6:00 PM | Sunday: Closed",
      office: "Office",
      phoneLabel: "Phone / Landline",
      emailLabel: "Email",
      hoursLabel: "Office Hours",
    },
    services: {
      hubLabel: "Services Hub",
      hubTitle: "Twelve ways we help you grow & protect wealth.",
      hubSub: "From mutual funds and equity to insurance, NPS, NRI services, PMS, REITs/InvITs, Bonds/FDs, AIF, loans and land & second homes facilitation — explore each service to see what's offered, the calculators we provide and answers to the most common questions.",
      titles: {
        "mutual-funds": "Mutual Fund Distribution",
        "goal-planning": "Goal-Based Financial Planning (Coming Soon)",
        "insurance": "Insurance Distribution",
        "nps": "National Pension System (NPS)",
        "nri": "NRI Investment Services",
        "pms": "Distribution of PMS Products",
        "reits": "REITs & InvITs",
        "bonds": "Bonds & Fixed Deposits",
        "equity": "Equity & Derivatives",
        "loans": "Home Loans & Loan against MF",
        "aif": "Alternative Investment Funds (AIF)",
        "land": "Land & Second Homes Facilitation",
      },
    },
    theme: { light: "Light", dark: "Dark" },
    language: "Language",
    common: { learnMore: "Learn more" },
  },
  hi: {
    nav: { home: "होम", about: "हमारे बारे में", services: "सेवाएँ", career: "करियर", contact: "संपर्क", calculators: "कैलकुलेटर", servicesHub: "सभी सेवाएँ" },
    cta: { start: "आज ही निवेश शुरू करें", talk: "विशेषज्ञ से बात करें", learnMore: "और जानें", submit: "भेजें", calculate: "गणना करें", book: "मुफ्त परामर्श बुक करें", viewAll: "सभी सेवाएँ देखें", back: "वापस" },
    hero: {
      headline: "एक समृद्ध कल के लिए आपका विश्वसनीय साथी",
      sub: "बेहतर निवेश। बेहतर योजना। अधिक उपलब्धि। — आर्थनीति फाइनेंशियल सर्विसेज़, एक AMFI-पंजीकृत म्यूचुअल फंड वितरक के साथ।",
      legacy: "25+ वर्षों की विरासत",
      caption: "व्यक्तिगत परामर्श जो आपके परिवार को पहले रखता है।",
      mumbai: "मुंबई · दादर (पूर्व)",
      badges: ["AMFI पंजीकृत", "NISM प्रमाणित", "अनेक खुश परिवार"],
    },
    stats: { aum: "वितरित AUM", families: "खुश परिवार", years: "वर्षों का विश्वास", amcs: "साझेदार AMCs" },
    sections: {
      services: "हमारी सेवाएँ", whyChoose: "आर्थनीति क्यों चुनें", whyTitle: "प्रौद्योगिकी पर निर्मित। संबंधों से संचालित।",
      how: "कैसे काम करता है", howTitle: "3 आसान चरणों में शुरू करें",
      testimonials: "हमारे ग्राहक क्या कहते हैं", testimonialsTitle: "एक-एक परिवार से अर्जित विश्वास।",
      partners: "विश्वसनीय साझेदार", partnersTitle: "40+ AMCs, शीर्ष बैंक और बीमाकर्ता",
      insurancePartners: "बीमा भागीदार", bankingPartners: "बैंकिंग भागीदार",
      faqs: "अक्सर पूछे जाने वाले प्रश्न", faqsLong: "FAQ",
      tools: "वित्तीय कैलकुलेटर", toolsLong: "उपकरण",
      team: "हमारी टीम", teamTitle: "आपके पोर्टफोलियो के पीछे के लोग।",
      values: "मूल मूल्य", valuesTitle: "छह सिद्धांत जो हर बातचीत को नियंत्रित करते हैं।",
      story: "हमारी कहानी", storyHeadline: "वित्त की नीति, 1999 से।",
      missionLabel: "मिशन", visionLabel: "विजन",
      regulatory: "विनियामक जानकारी", offerings: "मुख्य पेशकश और लाभ", categories: "हम जो श्रेणियाँ वितरित करते हैं",
    },
    footer: {
      compliance: "AMFI पंजीकृत म्यूचुअल फंड वितरक | ARN-40602",
      risk: "म्यूचुअल फंड निवेश बाजार जोखिमों के अधीन हैं। कृपया सभी योजना-संबंधी दस्तावेज़ ध्यान से पढ़ें।",
      office: "पंजीकृत कार्यालय", contact: "संपर्क", links: "त्वरित लिंक", services: "सेवाएँ",
      copyright: "© 2025 आर्थनीति फाइनेंशियल सर्विसेज़। सर्वाधिकार सुरक्षित।",
      disclaimer: "अस्वीकरण", privacy: "गोपनीयता नीति", terms: "उपयोग की शर्तें", grievance: "शिकायत निवारण",
    },
    contact: {
      title: "संपर्क करें", sub: "हम 24 कार्य घंटों में उत्तर देते हैं।", headline: "बातचीत शुरू करें।",
      name: "पूरा नाम", phone: "फ़ोन नंबर", email: "ईमेल", city: "शहर",
      topic: "हम आपकी कैसे सहायता कर सकते हैं?", topicPlaceholder: "विषय चुनें",
      message: "आपका संदेश", success: "धन्यवाद! हम 24 कार्य घंटों में संपर्क करेंगे।", sending: "भेजा जा रहा है...",
      whatsapp: "WhatsApp पर चैट करें", hours: "सोम – शनि: सुबह 10:00 – शाम 6:00 | रविवार: बंद",
      office: "कार्यालय", phoneLabel: "फ़ोन / लैंडलाइन", emailLabel: "ईमेल", hoursLabel: "कार्यालय समय",
    },
    services: {
      hubLabel: "सेवा केंद्र", hubTitle: "धन बढ़ाने और सुरक्षित रखने के बारह तरीके।",
      hubSub: "म्यूचुअल फंड और इक्विटी से लेकर बीमा, NPS, NRI सेवाएँ, PMS, REITs/InvITs, बॉन्ड/FDs, AIF, ऋण और भूमि व सेकंड होम सुविधा — प्रत्येक सेवा का अन्वेषण करें।",
      titles: {
        "mutual-funds": "म्यूचुअल फंड वितरण",
        "goal-planning": "लक्ष्य-आधारित वित्तीय योजना",
        "insurance": "बीमा वितरण",
        "nps": "राष्ट्रीय पेंशन प्रणाली (NPS)",
        "nri": "NRI निवेश सेवाएँ",
        "pms": "PMS उत्पादों का वितरण",
        "reits": "REITs और InvITs",
        "bonds": "बॉन्ड और सावधि जमा",
        "equity": "इक्विटी और डेरिवेटिव्स",
        "loans": "होम लोन और MF के विरुद्ध ऋण",
        "aif": "वैकल्पिक निवेश फंड (AIF)",
        "land": "भूमि और सेकंड होम सलाह",
      },
    },
    theme: { light: "लाइट", dark: "डार्क" },
    language: "भाषा",
    common: { learnMore: "और जानें" },
  },
  mr: {
    nav: { home: "मुख्यपृष्ठ", about: "आमच्याबद्दल", services: "सेवा", career: "करियर", contact: "संपर्क", calculators: "कॅल्क्युलेटर", servicesHub: "सर्व सेवा" },
    cta: { start: "आजच गुंतवणूक सुरू करा", talk: "तज्ज्ञांशी बोला", learnMore: "अधिक जाणून घ्या", submit: "पाठवा", calculate: "गणना करा", book: "मोफत सल्ला बुक करा", viewAll: "सर्व सेवा पहा", back: "मागे" },
    hero: {
      headline: "समृद्ध उद्यासाठी आपला विश्वासू साथीदार",
      sub: "हुशारीने गुंतवा. उत्तम योजना. अधिक साध्य. — आर्थनीती फायनान्शियल सर्व्हिसेस, AMFI-नोंदणीकृत म्युच्युअल फंड वितरकासह.",
      legacy: "25+ वर्षांचा वारसा", caption: "वैयक्तिक सल्ला जो आपल्या कुटुंबाला प्राथमिकता देतो.",
      mumbai: "मुंबई · दादर (पूर्व)",
      badges: ["AMFI नोंदणीकृत", "NISM प्रमाणित", "अनेक आनंदी कुटुंबे"],
    },
    stats: { aum: "वितरित AUM", families: "आनंदी कुटुंबे", years: "वर्षांचा विश्वास", amcs: "भागीदार AMCs" },
    sections: {
      services: "आमच्या सेवा", whyChoose: "आर्थनीती का निवडावे", whyTitle: "तंत्रज्ञानावर आधारित. नातेसंबंधांनी समर्थित.",
      how: "कसे चालते", howTitle: "3 सोप्या टप्प्यांत सुरू करा",
      testimonials: "ग्राहक काय म्हणतात", testimonialsTitle: "प्रत्येक कुटुंबाकडून मिळवलेला विश्वास.",
      partners: "विश्वासू भागीदार", partnersTitle: "40+ AMCs, शीर्ष बँका आणि विमा कंपन्या",
      insurancePartners: "विमा भागीदार", bankingPartners: "बँकिंग भागीदार",
      faqs: "वारंवार विचारले जाणारे प्रश्न", faqsLong: "FAQ",
      tools: "आर्थिक कॅल्क्युलेटर", toolsLong: "साधने",
      team: "आमची टीम", teamTitle: "आपल्या पोर्टफोलिओमागील माणसे.",
      values: "मूळ मूल्ये", valuesTitle: "प्रत्येक संवाद नियंत्रित करणारी सहा तत्त्वे.",
      story: "आमची कहाणी", storyHeadline: "वित्ताचे धोरण, 1999 पासून.",
      missionLabel: "ध्येय", visionLabel: "दृष्टी",
      regulatory: "नियामक माहिती", offerings: "मुख्य ऑफरिंग आणि फायदे", categories: "आम्ही वितरित करत असलेल्या श्रेणी",
    },
    footer: {
      compliance: "AMFI-नोंदणीकृत म्युच्युअल फंड वितरक | ARN-40602",
      risk: "म्युच्युअल फंड गुंतवणूक बाजार जोखमींच्या अधीन आहे. कृपया सर्व योजना-संबंधित कागदपत्रे काळजीपूर्वक वाचा.",
      office: "नोंदणीकृत कार्यालय", contact: "संपर्क", links: "जलद दुवे", services: "सेवा",
      copyright: "© 2025 आर्थनीती फायनान्शियल सर्व्हिसेस. सर्व हक्क राखीव.",
      disclaimer: "अस्वीकरण", privacy: "गोपनीयता धोरण", terms: "वापराच्या अटी", grievance: "तक्रार निवारण",
    },
    contact: {
      title: "संपर्क साधा", sub: "आम्ही 24 व्यावसायिक तासांत प्रतिसाद देतो.", headline: "संभाषण सुरू करूया.",
      name: "पूर्ण नाव", phone: "फोन क्रमांक", email: "ईमेल", city: "शहर",
      topic: "आम्ही कशी मदत करू शकतो?", topicPlaceholder: "विषय निवडा",
      message: "आपला संदेश", success: "धन्यवाद! आम्ही 24 व्यावसायिक तासांत संपर्क करू.", sending: "पाठवत आहे...",
      whatsapp: "WhatsApp वर चॅट करा", hours: "सोम – शनि: सकाळी 10:00 – सायं. 6:00 | रविवार: बंद",
      office: "कार्यालय", phoneLabel: "फोन / लँडलाइन", emailLabel: "ईमेल", hoursLabel: "कार्यालयाची वेळ",
    },
    services: {
      hubLabel: "सेवा केंद्र", hubTitle: "संपत्ती वाढवण्याचे आणि संरक्षण करण्याचे बारा मार्ग.",
      hubSub: "म्युच्युअल फंड आणि इक्विटीपासून ते विमा, NPS, NRI सेवा, PMS, REITs/InvITs, बॉण्ड/FDs, AIF, कर्जे आणि जमीन व सेकंड होम सुविधा — प्रत्येक सेवा एक्सप्लोर करा.",
      titles: {
        "mutual-funds": "म्युच्युअल फंड वितरण",
        "goal-planning": "लक्ष्य-आधारित आर्थिक नियोजन",
        "insurance": "विमा वितरण",
        "nps": "राष्ट्रीय पेन्शन प्रणाली (NPS)",
        "nri": "NRI गुंतवणूक सेवा",
        "pms": "PMS उत्पादांचे वितरण",
        "reits": "REITs आणि InvITs",
        "bonds": "बॉण्ड आणि मुदत ठेवी",
        "equity": "इक्विटी आणि डेरिव्हेटिव्ह्ज",
        "loans": "होम लोन आणि MF वर कर्ज",
        "aif": "पर्यायी गुंतवणूक फंड (AIF)",
        "land": "जमीन व सेकंड होम सुविधा",
      },
    },
    theme: { light: "लाइट", dark: "डार्क" },
    language: "भाषा",
    common: { learnMore: "अधिक जाणून घ्या" },
  },
  gu: {
    nav: { home: "મુખ્ય", about: "અમારા વિશે", services: "સેવાઓ", career: "કારકિર્દી", contact: "સંપર્ક", calculators: "કેલ્ક્યુલેટર", servicesHub: "બધી સેવાઓ" },
    cta: { start: "આજે જ રોકાણ શરૂ કરો", talk: "નિષ્ણાત સાથે વાત કરો", learnMore: "વધુ જાણો", submit: "સબમિટ", calculate: "ગણતરી કરો", book: "મફત સલાહ બુક કરો", viewAll: "બધી સેવાઓ જુઓ", back: "પાછળ" },
    hero: {
      headline: "સમૃદ્ધ આવતીકાલ માટે તમારો વિશ્વસનીય ભાગીદાર",
      sub: "સ્માર્ટ રોકાણ. વધુ સારી યોજના. વધુ સિદ્ધિ. — આર્થનીતિ ફાઇનાન્સિયલ સર્વિસીસ, AMFI-નોંધાયેલ મ્યુચ્યુઅલ ફંડ વિતરક સાથે.",
      legacy: "25+ વર્ષોનો વારસો", caption: "વ્યક્તિગત સલાહ જે તમારા પરિવારને પ્રથમ રાખે છે.",
      mumbai: "મુંબઈ · દાદર (પૂર્વ)",
      badges: ["AMFI નોંધાયેલ", "NISM પ્રમાણિત", "અનેક ખુશ પરિવારો"],
    },
    stats: { aum: "વિતરિત AUM", families: "ખુશ પરિવારો", years: "વર્ષોનો વિશ્વાસ", amcs: "ભાગીદાર AMCs" },
    sections: {
      services: "અમારી સેવાઓ", whyChoose: "આર્થનીતિ કેમ પસંદ કરો", whyTitle: "ટેકનોલોજી પર બનેલ. સંબંધો દ્વારા સંચાલિત.",
      how: "કેવી રીતે કાર્ય કરે", howTitle: "3 સરળ પગલાંમાં શરૂ કરો",
      testimonials: "ગ્રાહકો શું કહે છે", testimonialsTitle: "દરેક પરિવાર પાસેથી મેળવેલો વિશ્વાસ.",
      partners: "વિશ્વસનીય ભાગીદારો", partnersTitle: "40+ AMCs, ટોચની બેંકો અને વીમા કંપનીઓ",
      insurancePartners: "વીમા ભાગીદારો", bankingPartners: "બેંકિંગ ભાગીદારો",
      faqs: "વારંવાર પૂછાતા પ્રશ્નો", faqsLong: "FAQ",
      tools: "નાણાકીય કેલ્ક્યુલેટર", toolsLong: "સાધનો",
      team: "અમારી ટીમ", teamTitle: "તમારા પોર્ટફોલિયો પાછળના લોકો.",
      values: "મૂળ મૂલ્યો", valuesTitle: "દરેક ક્રિયાપ્રતિક્રિયાને નિયંત્રિત કરતા છ સિદ્ધાંતો.",
      story: "અમારી વાર્તા", storyHeadline: "નાણાંની નીતિ, 1999 થી.",
      missionLabel: "મિશન", visionLabel: "વિઝન",
      regulatory: "નિયમનકારી માહિતી", offerings: "મુખ્ય ઓફરિંગ અને લાભો", categories: "અમે વિતરિત કરીએ છીએ તે શ્રેણીઓ",
    },
    footer: {
      compliance: "AMFI-નોંધાયેલ મ્યુચ્યુઅલ ફંડ વિતરક | ARN-40602",
      risk: "મ્યુચ્યુઅલ ફંડ રોકાણ બજાર જોખમોને આધીન છે. કૃપા કરીને બધા સ્કીમ-સંબંધિત દસ્તાવેજો ધ્યાનથી વાંચો.",
      office: "નોંધાયેલ કાર્યાલય", contact: "સંપર્ક", links: "ઝડપી લિંક્સ", services: "સેવાઓ",
      copyright: "© 2025 આર્થનીતિ ફાઇનાન્સિયલ સર્વિસીસ. બધા હક અનામત.",
      disclaimer: "અસ્વીકરણ", privacy: "ગોપનીયતા નીતિ", terms: "ઉપયોગની શરતો", grievance: "ફરિયાદ નિવારણ",
    },
    contact: {
      title: "સંપર્કમાં રહો", sub: "અમે 24 વ્યવસાય કલાકોમાં જવાબ આપીએ છીએ.", headline: "ચાલો વાતચીત શરૂ કરીએ.",
      name: "પૂરું નામ", phone: "ફોન નંબર", email: "ઈમેલ", city: "શહેર",
      topic: "અમે કેવી રીતે મદદ કરી શકીએ?", topicPlaceholder: "વિષય પસંદ કરો",
      message: "તમારો સંદેશ", success: "આભાર! અમે 24 વ્યવસાય કલાકોમાં સંપર્ક કરીશું.", sending: "મોકલી રહ્યું છે...",
      whatsapp: "WhatsApp પર ચેટ કરો", hours: "સોમ – શનિ: સવારે 10:00 – સાંજે 6:00 | રવિવાર: બંધ",
      office: "કાર્યાલય", phoneLabel: "ફોન / લેન્ડલાઈન", emailLabel: "ઈમેલ", hoursLabel: "કાર્યાલય સમય",
    },
    services: {
      hubLabel: "સેવા કેન્દ્ર", hubTitle: "સંપત્તિ વધારવા અને સુરક્ષિત રાખવાના બાર રસ્તા.",
      hubSub: "મ્યુચ્યુઅલ ફંડ અને ઇક્વિટીથી લઈને વીમો, NPS, NRI સેવાઓ, PMS, REITs/InvITs, બોન્ડ/FDs, AIF, લોન અને જમીન અને બીજા ઘરની સુવિધા સુધી — દરેક સેવા એક્સપ્લોર કરો.",
      titles: {
        "mutual-funds": "મ્યુચ્યુઅલ ફંડ વિતરણ",
        "goal-planning": "ધ્યેય-આધારિત નાણાકીય આયોજન",
        "insurance": "વીમા વિતરણ",
        "nps": "રાષ્ટ્રીય પેન્શન સિસ્ટમ (NPS)",
        "nri": "NRI રોકાણ સેવાઓ",
        "pms": "PMS ઉત્પાદોનું વિતરણ",
        "reits": "REITs અને InvITs",
        "bonds": "બોન્ડ અને ફિક્સ્ડ ડિપોઝિટ",
        "equity": "ઇક્વિટી અને ડેરિવેટિવ્ઝ",
        "loans": "હોમ લોન અને MF સામે લોન",
        "aif": "વૈકલ્પિક રોકાણ ફંડ (AIF)",
      },
    },
    theme: { light: "લાઇટ", dark: "ડાર્ક" },
    language: "ભાષા",
    common: { learnMore: "વધુ જાણો" },
  },
};

export function t(lang, path) {
  const keys = path.split(".");
  let cur = dict[lang] || dict.en;
  for (const k of keys) {
    if (cur && typeof cur === "object" && k in cur) cur = cur[k];
    else {
      cur = dict.en;
      for (const k2 of keys) cur = cur?.[k2];
      return cur ?? path;
    }
  }
  return cur;
}

export default dict;
